import React, { useState, useEffect } from 'react';
import './App.css';
import LoadingScreen from './components/LoadingScreen';
import ProductCard from './components/ProductCard';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const products = [
    {
      id: 1,
      name: 'FASE',
      description: 'Protocol Generating Platform',
      features: [
        'Largest Curated Database Of Clinical Trials',
        'Integrated Clinical Competitive Intelligence',
        'Comply with FDA, ICH, EU and local GCP frameworks'
      ],
      color: '#184091',
      accentColor: '#4A90E2',
      url: 'https://qa.fase.b1healthcorp.com'
    },
    {
      id: 2,
      name: 'MDash',
      description: 'Quick Evidence/Insights',
      features: [
        'Disease Landscape / Patient Journey',
        'Geographical Patient Finder',
        'Competitive Medical Intelligence'
      ],
      color: '#008B8B',
      accentColor: '#00C9A7',
      url: 'https://mdash.b1healthcorp.com'
    },
    {
      id: 3,
      name: 'MDash Edge',
      description: 'Medical Project Management',
      features: [
        'Processes Tracker',
        'KOL Outreach Management',
        'Integrated Evidence Generation'
      ],
      color: '#87A96B',
      accentColor: '#A8C686',
      url: 'https://edge.b1healthcorp.com'
    },
    {
      id: 4,
      name: 'KOLodex',
      description: 'KOL Finder',
      features: [
        'Prescription Finder',
        'Similar Profiles',
        'Competitive Engagement'
      ],
      color: '#2c5aa0',
      accentColor: '#4A90E2',
      url: 'https://kolodex.b1healthcorp.com'
    }
  ];

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="app">
      <header className="app-header clickable-header" onClick={() => window.open('https://b1healthcorp.com', '_blank', 'noopener,noreferrer')}>
        <div className="header-content">
          <div className="header-brand">
            <img src="/B1Logo.png" alt="B1 Health Corp Logo" className="company-logo" />
            <div className="brand-text">
              <h1 className="app-title">B1 Health Corp</h1>
              <p className="app-subtitle">
              Supporting Life Science Companies In Bringing Products To Market Faster
              </p>
            </div>
          </div>
        </div>
      </header>
      
      <main className="app-main">
        <div className="products-grid">
          {products.map((product, index) => (
            <ProductCard
              key={product.id}
              product={product}
              index={index}
            />
          ))}
        </div>
      </main>
      
      <footer className="app-footer">
        <p>&copy; 2025 B1 Health Corp. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default App;
